import { ApiAccountDashboardModelPortfolio } from 'api/rtk-api'
import { ValueSunburstWithTable } from 'components/core-v2'

import classes from './index.module.scss'

interface Props {
  portfolios: ApiAccountDashboardModelPortfolio[]
}
export const TaxClassificationTab = ({ portfolios }: Props) => {
  const series = portfolios.reduce(
    (acc, portfolio) => {
      const type = acc.find(type => type.name === portfolio.taxClassification)
      type.count += portfolio?.numberOfActiveAccounts || 0
      type.value += portfolio?.zarValue || 0

      return acc
    },
    [
      { name: 'Capital', count: 0, value: 0, parent: '0', id: 'Capital' },
      { name: 'Yield', count: 0, value: 0, parent: '0', id: 'Yield' }
    ]
  )

  return (
    <ValueSunburstWithTable
      allowTooltipOutside={false}
      className={classes.sunburstWrapper}
      data={series}
      seriesName="Tax classification"
      tableWidth="100%"
    />
  )
}
